module.exports = __webpack_public_path__ + "static/media/autodesk_atlas_thumb.26ae04a0.png";